import { Box, Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import BaseImage from "../BaseImage"
import BaseLink from "../BaseLink"

import IconLockCircleBg from "../../assets/images/icons/icon-lock-circle-bg.svg"
import { openModal } from "../../store"

const HealthReportCard = ({ data, isHome = false, sx }) => {
  const dispatch = useDispatch()

  const handleClickLockReport = () => {
    dispatch(
      openModal({
        currentModal: 'Lock_REPORT_MODAL',
    }))
  }

  return (
    <Box
      sx={{
        height: '100%',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'primary.lightBlue',
        boxShadow: '0px 2px 10px 0px rgba(91, 135, 239, 0.20)',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        ...sx
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
          width: '100%',
          height: '100%',
          background: '#0E0F1099',
          backdropFilter: 'blur(7.5px)',
          borderRadius: '8px',
          display: data?.locked ? 'flex' : 'none',
          boxShadow: '0px 2px 10px 0px rgba(91, 135, 239, 0.20)',
          alignItems: 'center',
          justifyContent: 'center',
          px: '8px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            textAlign: 'center'
          }}
          onClick={handleClickLockReport}
        >
          <BaseImage 
            src={IconLockCircleBg}
            sx={{
              width: '48px',
              height: '48px',
              mb: '8px'
            }}
          />
          <Typography
            variant="h4"
            color="white"
          >
            {data?.name}
          </Typography>
        </Box>
      </Box>
      <BaseLink to={data?.link} sx={{ height: '100%' }}>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <Box>
            <BaseImage
              src={data?.icon}
              sx={{
                width: '40px',
                height: '40px',
                mb: '30px'
              }}
              alt={data?.name}
            />
            <Typography
              variant="h4"
              color="primary.black"
              sx={{
                mt: "8px",
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {data?.name}
            </Typography>
            {!isHome && (
              <Typography
                variant="subText"
                color="primary.darkGray"
              >
                {data?.date}
              </Typography>
            )}
          </Box>
          <Box>
            <Typography
              variant="subText"
              color="primary.white"
              bgcolor={ data?.priority === 0 ? 'primary.darkGreen' : 'primary.red' }
              sx={{
                padding: '1px 7px 1px 7px',
                borderRadius: '4px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}
            >
              {data?.priority} Priority results
            </Typography>
          </Box>
        </Box>
      </BaseLink>
    </Box>
  )
}

export default HealthReportCard